import React, { useEffect } from 'react';
import { pageTitle } from '../../helper';
import Cta from '../Cta';
import PageHeading from '../PageHeading';
import Div from '../Div';
import SectionHeading from '../SectionHeading';
import Spacing from '../Spacing';
import Team from '../Team';
import { useNavigate } from 'react-router-dom';

export default function TeamPage() {
  pageTitle('Team');
  const navigate = useNavigate();

  const teamData = [
    // {
    //   memberImage: '/images/gul.jpg',
    //   memberName: 'Gul Azeem',
    //   memberDesignation: 'CEO',
    //   bio: 'Gül is a seasoned entrepreneur and digital innovator with extensive experience in developing and implementing technology-driven strategic business solutions across three continents. She is a passionate advocate for workspace equality and merit-based equity in the marketplace. Gül has collaborated with prestigious global brands, guiding them in transforming their vision into actionable and teachable processes. Currently, she leads RLAB and its subsidiaries, driving impactful change and innovation.',
    //   memberSocial: {
    //     linkedin: '/',
    //     twitter: '/',
    //     youtube: '/',
    //     facebook: '/',
    //   },
    // },
    {
      memberImage: '/images/guy.jpg',
      memberName: 'Guy Morris',
      memberDesignation: 'Sales and Marketing',
      bio: 'Guy Morris serves as the Director of Sales and Marketing, where he is responsible for shaping and accelerating the company’s marketing strategy and enhancing brand presence across North America, Asia, and the Middle East. His expertise extends to ideation, product development, and solution innovation. With a keen interest in off world technologies, aerospace, finance, green energy, and fintech, Guy is leading several targeted product initiatives through RLAB’s innovation sector.',
      memberSocial: {
        linkedin: '/',
        twitter: '/',
        youtube: '/',
        facebook: '/',
      },
    },
    // {
    //   memberImage: '/images/team-placeholder.png',
    //   memberName: 'Misal Azeem',
    //   bio: 'Misal Azeem is a certified full stack developer with a strong emphasis on agile development methodologies. He is dedicated to creating effective and innovative technology solutions. With extensive experience in leading cross-functional teams, Misal excels in driving projects from concept to completion, ensuring alignment with business goals and user needs. His passion for technology and commitment to continuous improvement empower him to deliver results that enhance operational efficiency and foster growth.',
    //   memberDesignation: 'Full Stack design and development',
    //   memberSocial: {
    //     linkedin: '/',
    //     twitter: '/',
    //     youtube: '/',
    //     facebook: '/',
    //   },
    // },
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleMemberClick = (member) => {
    // Navigate to the details page and pass the `member` object via state
    navigate('/team-details', { state: member });
  };

  return (
    <>
      <PageHeading
        title="Our Team"
        bgSrc="images/team_hero_bg.webp"
        pageLinkText="Team"
      />
      <Spacing lg="145" md="80" />
      <Div className="container">
        <SectionHeading
          title="Meet our Leadership Team"
          subtitle="Our Team"
          variant="cs-style1 text-center"
        />
        <Spacing lg="90" md="45" />
        <Div className="row">
          {teamData.map((item, index) => (
            <Div key={index} className="col-lg-3 col-sm-6">
              <Team
                memberImage={item.memberImage}
                memberName={item.memberName}
                bio={item.bio}
                memberDesignation={item.memberDesignation}
                memberSocial={item.memberSocial}
                // Pass a callback to handle click
                onClick={() => handleMemberClick(item)}
              />
              <Spacing lg="80" md="30" />
            </Div>
          ))}
        </Div>
        <Spacing lg="70" md="50" />
        <Div className="container">
          <Cta
            title="Let’s collaborate make <br />something <i>exceptional</i> together"
            btnText="Apply For Meeting"
            btnLink="/contact"
            bgSrc="/images/cta_bg.jpeg"
          />
        </Div>
      </Div>
    </>
  );
}
